var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { active: _vm.showUninstaller, scroll: "keep" },
      on: {
        "update:active": function ($event) {
          _vm.showUninstaller = $event
        },
        close: _vm.cancelar,
      },
    },
    [
      _c("div", { staticClass: "notification is-danger" }, [
        _c("h1", { staticClass: "title is-4 has-text-centered" }, [
          _c("i", { staticClass: "fas fa-trash fa-fw" }),
          _vm._v(" ¿Está seguro que desea desinstalar el modulo?"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "buttons has-text-centered" }, [
          _c(
            "button",
            {
              staticClass: "button is-white is-outlined",
              on: { click: _vm.cancelar },
            },
            [_vm._v("Cancelar")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button is-danger is-inverted",
              on: { click: _vm.desinstalar },
            },
            [_vm._v("Desinstalar")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }